import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { autorun } from 'mobx';
import { IDistribution } from '../../../model/distributions/Distribution';
import { IEntityVersionVm } from '@yakoffice/publisher-types';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useDistributedEntitiesResult {
    isLoaded: boolean;
    entityVersions: IEntityVersionVm[];
}

export const useDistributedEntities = (distribution: IDistribution | null) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useDistributedEntitiesResult>({ isLoaded: false, entityVersions: [] });

    useEffect(() => {
        autorun(() => {
            setResult({ isLoaded: false, entityVersions: [] });

            const entityVersionLoader = distribution != null
                ? () => rootStore.entityVersionStore.getDistributedEntityVersions(distribution.id)
                : () => rootStore.entityVersionStore.getPublishedEntityVersions();

            entityVersionLoader()
                .then((entities) => {
                    setResult({ isLoaded: true, entityVersions: entities });
                })
                .catch(e => publishNotification({
                    text: 'Error loading distributed entities',
                    canClose: true
                }));
        });
    }, [rootStore.entityVersionStore, publishNotification, distribution]);

    return result;
};
